import React from 'react';
import ReactDOM from 'react-dom';

import Modal from './index';

//  getElementById is used on mount, so tests keep working
class ModalState extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    let modal = document.getElementById('modal');

    if (!modal) {
      modal = document.createElement('div');
      modal.setAttribute('id', 'modal');
      document.body.appendChild(modal);
    }

    this.modal = modal;

    this.modal.appendChild(this.el);
  }

  componentWillUnmount() {
    this.modal.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(<Modal {...this.props} />, this.el);
  }
}

export default ModalState;



// WEBPACK FOOTER //
// ../ui-components/components/ModalNew/modal.state.jsx